import { Indicator } from "@mantine/core";

type StatusIndicatorProps = {
  active: boolean;
};

export function StatusIndicator({ active }: StatusIndicatorProps) {
  return <Indicator zIndex={0} position="middle-center" color={active ? "zli-green" : "red"} />;
}
